import { CSSObject } from '@chakra-ui/react';

export const Accordion: CSSObject = {
  border: 'transparent',
  overflow: 'hidden',
  borderRadius: 'md',
  '.chakra-accordion__item': {
    mb: '2',
    bg: 'rgba(0, 209, 255, 0.25)',
    boxShadow:
      '0px 4px 6px 0px rgba(0, 0, 0, 0.15), 0px 0px 0px 1px rgba(255, 255, 255, 0.2) inset',
    borderRadius: 'md',
  },
  '.chakra-accordion__panel': {
    color: 'white',
    borderTop: '2px solid',
    borderTopColor: 'whiteAlpha.200',
    pt: '3',
    '.chakra-text': {
      _first: {
        color: 'white',
        fontSize: 'xs',
        fontFamily: 'accent',
        fontWeight: 'semiBold',
        px: '0.5',
      },
      _notFirst: {
        borderRadius: 'base',
        bg: 'alpha.800',
        color: 'whiteAlpha.700',
        opacity: '0.5',
        border: 'none',
      },
    },
  },
};
export const AccordionHeader: CSSObject = {
  color: 'white',
  transitionDuration: 'normal',
  transitionProperty: 'common',
  fontFamily: 'accent',
  fontSize: 'sm',
  '.chakra-accordion__icon': {
    boxSize: '6',
    color: 'beta.300',
  },
  _hover: {
    bg: 'blackAlpha.300',
    color: 'white',
  },
  _focus: {
    bg: 'blackAlpha.300',
    color: 'white',
  },
};
export const OverviewPromotionsPanel: CSSObject = {
  color: 'white',
  '.chakra-checkbox__control': {
    borderRadius: 'xs',
    border: '1px solid black',
  },
};
export const AccordionHeaderLogOut: CSSObject = {
  bg: 'rgba(0, 209, 255, 0.25)',
  boxShadow:
    '0px 4px 6px 0px rgba(0, 0, 0, 0.15), 0px 0px 0px 1px rgba(255, 255, 255, 0.2) inset',
  borderRadius: 'md',
  fontFamily: 'accent',
  fontSize: 'sm',
  border: 'none',
  px: '3',
  _hover: {
    bg: 'blackAlpha.300',
    color: 'white',
  },
  _focus: {
    bg: 'blackAlpha.300',
    color: 'white',
  },
  _last: {
    mb: '1',
  },
};
export const IconPerson: CSSObject = {
  '&&': {
    display: 'none',
  },
};
export const TextAccordion: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  fontFamily: 'accent',
  mr: 'auto',
  mt: '1',
};
export const FlexContactToChange: CSSObject = {
  alignItems: 'center',
  justifyContent: 'center',
  bg: 'beta.400',
  borderRadius: 'base',
  boxShadow: '0px 3px 5px 0px rgba(0, 0, 0, 0.20)',
  fontSize: 'xs',
  fontWeight: 'normal',
  gap: '1',
  p: '2',
  '.chakra-text': {
    color: 'var(--bc-colors-beta-600) !important',
  },
  '.chakra-icon': {
    display: 'none',
  },
};
export const OverviewAccordionItem: CSSObject = {
  '.chakra-checkbox__label': {
    color: 'white',
  },
  border: 'none',
  bg: 'alpha.500',
  mb: '0',
  boxShadow:
    '0px 0px 0px 1px rgba(55, 140, 255, 0.50) inset, 0px 4px 10px 0px rgba(0, 0, 0, 0.30)',
};
